// Single place for every public marketing page's SEO metadata — title,
// description, keywords, and the canonical path Layout builds the
// <link rel="canonical"> and og:url from. Keep this in sync with
// src/pages/website/routes.tsx and public/sitemap.xml.

export const SEO_DEFAULTS = {
  siteUrl: "https://www.invyntra.in",
  ogImage: "/og-image.png",
  twitterCard: "summary_large_image",
};

export interface PageSeo {
  path: string;
  title: string;
  description: string;
  keywords: string;
}

export const PAGE_SEO = {
  home: {
    path: "/",
    title: "Invyntra — Inventory Management for Small Businesses in India",
    description:
      "Track stock, purchases, sales, and GST billing across every warehouse in one dashboard. Built for small and growing Indian businesses. Start free — no credit card required.",
    keywords:
      "inventory management software India, stock management software, GST billing software, warehouse management system, small business inventory software, purchase order software, sales order management, multi warehouse inventory",
  },
  about: {
    path: "/about",
    title: "About — Invyntra",
    description:
      "Invyntra is a new inventory management platform built to make stock, purchase, and sales tracking effortless for small and growing businesses.",
    keywords:
      "about Invyntra, inventory management company India, small business software team",
  },
  pricing: {
    path: "/pricing",
    title: "Pricing — Invyntra",
    description:
      "Simple, usage-based pricing for Invyntra's inventory management platform. Start with a free 15-day trial, upgrade as you grow.",
    keywords:
      "inventory software pricing India, stock management software price, GST billing software cost, inventory management plans, free trial inventory software",
  },
  contact: {
    path: "/contact",
    title: "Contact — Invyntra",
    description:
      "Have questions or want early access to Invyntra? Send us a message or chat with us on WhatsApp and we'll get back to you.",
    keywords:
      "contact Invyntra, Invyntra support, Invyntra demo, inventory software support India",
  },
  faqs: {
    path: "/faqs",
    title: "FAQs — Invyntra",
    description:
      "Answers to common questions about Invyntra's inventory management platform — trial, multi-branch support, and reporting.",
    keywords:
      "Invyntra FAQ, inventory software questions, free trial inventory software, GST billing software FAQ",
  },
  terms: {
    path: "/terms",
    title: "Terms & Conditions — Invyntra",
    description: "The terms that govern use of the Invyntra platform.",
    keywords: "Invyntra terms and conditions, terms of service",
  },
  privacy: {
    path: "/privacy",
    title: "Privacy Policy — Invyntra",
    description: "How Invyntra collects, uses, and protects your data.",
    keywords: "Invyntra privacy policy, data protection, inventory software privacy",
  },
} satisfies Record<string, PageSeo>;
